module.exports = __webpack_public_path__ + "static/img/footer3.f12ac2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer3.png
// module id = fnAk
// module chunks = 1